// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".TabContent_wrapper__1Z6Ts.TabContent_isNotFound__2rXAb > div {\n  min-height: 324px; }\n\n.TabContent_wrapper__1Z6Ts:not(.TabContent_isNotFound__2rXAb) > div {\n  max-height: 500px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  position: relative; }\n  .TabContent_wrapper__1Z6Ts:not(.TabContent_isNotFound__2rXAb) > div > div {\n    border-bottom: 1px solid #f7f7f7; }\n    .TabContent_wrapper__1Z6Ts:not(.TabContent_isNotFound__2rXAb) > div > div:last-child {\n      border-bottom: 0; }\n\n.TabContent_wrapper__1Z6Ts:not(.TabContent_isNotFound__2rXAb) .TabContent_bottomMark__2h8ce {\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  right: 0; }\n\n.TabContent_notFound__1gwqB {\n  margin-top: 32px; }\n", ""]);
// Exports
exports.locals = {
	"wrapper": "TabContent_wrapper__1Z6Ts",
	"isNotFound": "TabContent_isNotFound__2rXAb",
	"bottomMark": "TabContent_bottomMark__2h8ce",
	"notFound": "TabContent_notFound__1gwqB"
};
module.exports = exports;
